import { NutricionalDataKeys } from 'config/recipes';

const recipeDiffer = (recipe) => ({
  title: (title = '') => recipe.title !== title,
  ingredients: (ingredients = []) => {
    if (recipe.ingredients.length !== ingredients.length) return true;

    for (let i = 0; i < ingredients.length; i++)
      if (
        ingredients[i].ingredientText !== recipe.ingredients[i].ingredientText
      )
        return true;

    return false;
  },
  timeToPrepare: (timeToPrepare = '') => timeToPrepare !== recipe.timeToPrepare,
  directions: (directions = []) => {
    if (directions.length !== recipe.directions.length) return true;

    for (let i = 0; i < directions.length; i++)
      if (directions[i].directionText !== recipe.directions[i].directionText)
        return true;

    return false;
  },
  additionalData: (additionalData = {}) => {
    if (additionalData.servings !== recipe.additionalData.servings) return true;

    if (additionalData.description !== recipe.additionalData.description)
      return true;

    for (const key of NutricionalDataKeys)
      if (
        additionalData.nutricionalData[key] !==
        recipe.additionalData.nutricionalData[key]
      )
        return true;

    if (additionalData.coverPhotoURL !== recipe.additionalData.coverPhotoURL)
      return true;

    return false;
  },
});

export default recipeDiffer;
